// src/features/feeds/useFeeds.ts

import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { FeedApi } from './FeedApi';
import { FEED_QUERY_KEYS } from '@/lib/constants/feed';
import { useAuth } from '@/features/auth/hooks/useAuth';
import type { FeedData } from '@/lib/types/Feed';

export function useFeeds() {
  const { selectedCId } = useAuth();

  const query = useQuery({
    queryKey: FEED_QUERY_KEYS.list(selectedCId ?? 0),
    queryFn: async () => {
      const result = await FeedApi.getFeeds(selectedCId!);
      return result.data; // Unwrap IListRes<FeedData> -> FeedData[]
    },
    enabled: selectedCId != null,
    staleTime: 2 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  const feeds: FeedData[] = useMemo(() => query.data ?? [], [query.data]);

  return {
    feeds,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  };
}
